import React, { FC, memo, useMemo } from 'react';
import styled from 'styled-components';
import UdeskLocales from 'UdeskLocales';

const Wrapper = styled.div`
    font-weight: bold;
`;

const Mark = styled.span`
    color: ${(props) => (props.type === 'light' ? '#ccc' : '#000')};
    font-weight: normal;
    font-size: 12px;
    margin: 0 5px;
`;

interface TemplateProps {
    idx?: number;
    type?: string;
    text?: string;
}

const Template: FC<TemplateProps> = memo(({ idx = 0, type, text }) => {
    const questionTypeLabel = useMemo(() => {
        switch (type) {
            case 'radio':
                return /* 单选题 */ UdeskLocales['current'].components.survey.components.question
                    .index.singleTopic;
            case 'checkbox':
                return /* 多选题 */ UdeskLocales['current'].components.survey.components.question
                    .index.multipleChoiceQuestions;
            case 'text':
                return /* 问答题 */ UdeskLocales['current'].components.survey.components.question
                    .index.questionAndAnswer;
            default:
                return /* 问答题 */ UdeskLocales['current'].components.survey.components.question
                    .index.questionAndAnswer;
        }
    }, [type]);

    return (
        <Wrapper>
            <span>{idx + 1}.</span>
            <span>{text}</span>
            <Mark type="light">{`[${questionTypeLabel}]`}</Mark>
        </Wrapper>
    );
});

export default Template;
